import React from "react";
import styled from "styled-components";
import {getProfileValue, IRewardPoints} from 'apps/BWW_PLAY_HUB/components/HubStats/utils';
import { HubStatsCount } from "apps/BWW_PLAY_HUB/components/HubStats/styles";
import { map } from "lodash";


const ProgressBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 240px;
    height: 240px;
    position: relative;
    margin-bottom: 30px;
`;

const Chart = styled.div`
	text-align: center;
	transform: rotate(-90deg);
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	#cont {
		display: block;
		height: 200px;
		width: 200px;
		margin: 2em auto;
		box-shadow: 0 0 1em black;
		border-radius: 100%;
		position: relative;
	}

	#cont:after {
		position: absolute;
		display: block;
		height: 160px;
		width: 160px;
		left: 50%;
		top: 50%;
		box-shadow: inset 0 0 1em black;
		content: attr(data-pct)"%";
		margin-top: -80px;
		margin-left: -80px;
		border-radius: 100%;
		line-height: 160px;
		font-size: 2em;
		text-shadow: 0 0 0.5em black;
	}

	#svg circle {
		transition: stroke-dashoffset 1s linear;
		stroke-width: 2.5em;
	}
`;

const RADIUS = 100;

interface IStatsCircleBar {
	items: IRewardPoints[],
	count_value?: number;
}

export const HubStatsCircleBar: React.FC<IStatsCircleBar> = ({ items, count_value = null }) => {
	const circle_path = Math.PI * 2 * RADIUS;

	const getPathLength = (percents: number = 0) => {
		return ( ( 100 - percents ) / 100 ) * circle_path;
	};

	let sum = 0;
	const items_reverse = [...items].reverse();
	const sum_percents = items_reverse.map((elem) => sum = sum + elem.percent).reverse();

	return (
		<ProgressBar>
			{ Boolean(count_value) && (
				<Chart>
					<svg id="svg" width="240" height="240">
						{ map(items, (item, index: number) => {
							const strokeDasharray = (index === 0) ? 0 : getPathLength(sum_percents[index]);
							const strokeDashoffset = (index === 0) ? 0 : getPathLength(sum_percents[index]);

							return (
								<circle
									key={index}
									r={RADIUS}
									cx="120"
									cy="120"
									fill="transparent"
									stroke={item.color}
									strokeDasharray={strokeDasharray}
									strokeDashoffset={strokeDashoffset}
								/>
							);
						})}
					</svg>
				</Chart>
			)}
			<HubStatsCount>{getProfileValue(count_value)}</HubStatsCount>
		</ProgressBar>
	);
};
